import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import { legalEntityEmployees } from 'modules/employees/store/collections/employeeGroupEmployees'

import useDownloadFile from 'modules/employees/hooks/useDownloadFile'

interface Props {
  legalEntity: LegalEntity
  downloadPath: string
  checkDownload?: string
  errorWrapperField?: Field
}

const LegalEntityButton = ({
  legalEntity,
  downloadPath,
  checkDownload,
  errorWrapperField,
}: Props) => {
  const api = React.useRef(ApiClient()).current

  const { running: downloading, onSubmit: onDownloadRequest } = useDownloadFile({
    api: api,
    legalEntityId: legalEntity.id,
    downloadPath: downloadPath,
    checkDownload: checkDownload,
  })

  const onEmptyLegalEntityDownloadRequest = (event: React.SyntheticEvent<Element, Event>) => {
    // This solution is temporal until we have a better way to display errors within the modal.
    if (errorWrapperField) {
      errorWrapperField.setErrors([i18n.t('import_contract.legal_entity_with_no_employees')])
    } else {
      onDownloadRequest()
    }
  }

  return (
    <Button
      onClick={
        legalEntityEmployees(legalEntity).length > 0
          ? onDownloadRequest
          : onEmptyLegalEntityDownloadRequest
      }
      disabled={downloading}
      type="secondary"
      title={legalEntity.name}
    >
      {legalEntity.name}
    </Button>
  )
}

export default observer(LegalEntityButton)
